import {
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
} from "../components/Component";
import { Tooltip } from "react-tooltip";
import Usericon from "../assets/images/add_user_icon.png";
import DropdownsPage from "../pages/components/Dropdowns";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Popover,
  PopoverBody,
  PopoverHeader,
} from "reactstrap";
import { useState } from "react";
import { useNavigate } from "react-router";

export const CustomHeader = ({ cart, logoData, showLogo, handleCheckout }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  function openInNewTab(url) {
    window.open(url, "_blank", "noopener,noreferrer");
  }

  const isTokenValid = () => {
    if (
      localStorage.getItem("jwt_ahrvo") ||
      localStorage.getItem("jwt-ahrvo")
    ) {
      return true;
    }
    return false;
  };

  const navigate = useNavigate();
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  return (
    <BlockHead size="sm">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {!isTokenValid() ? (
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <h5 style={{ paddingBottom: "0.5rem", fontSize: "1rem" }}>
                For Suppliers
              </h5>
              <Button
                onClick={() => openInNewTab("https://ahrvo.com/partnerships/")}
                outline={true}
                color={"primary"}
                style={{
                  border: "1px solid rgb(98, 178, 70)",
                  background: "rgb(98, 178, 70)",
                  color: "white",
                }}
              >
                Sign Up
              </Button>
            </div>
            <div
              style={{
                width: "1px",
                border: "1px solid #ddd",
                marginLeft: "1rem",
                marginRight: "1rem",
              }}
            ></div>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <h5 style={{ paddingBottom: "0.5rem", fontSize: "1rem" }}>
                For Buyers
              </h5>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  onClick={() => navigate("/login")}
                  outline={true}
                  color={"primary"}
                  style={{
                    border: "1px solid rgb(98, 178, 70)",
                    background: "rgb(98, 178, 70)",
                    color: "white",
                  }}
                >
                  Sign In
                </Button>
                <a
                  data-tooltip-id="my-tooltip"
                  data-tooltip-html={`
                <p>
                  Before signing in, please complete checkout and onboarding.
                  Add items to your cart using the toggle feature to get
                  started. <br />Once your onboarding is complete, you'll be able to
                  sign in and access your account seamlessly.
                </p>
              `}
                  data-tooltip-place="bottom"
                >
                  <em
                    style={{ fontSize: "1.5rem", marginLeft: "0.5rem" }}
                    class="icon ni ni-alert-circle-fill"
                  ></em>
                </a>
                <Tooltip id="my-tooltip" />
              </div>
            </div>
          </div>
        ) : (
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle
              className="btn-action"
              style={{
                background: "rgb(98, 178, 70)",
                color: "white",
                height: "3rem",
                padding: "1rem",
              }}
              color="rgb(98, 178, 70)"
            >
              <Icon name={"user-alt"}></Icon>
            </DropdownToggle>
            <DropdownMenu>
              <ul className="link-list-opt">
                <li>
                  <DropdownItem
                    tag="a"
                    href="#links"
                    onClick={(ev) => {
                      ev.preventDefault();
                      navigate("/");
                    }}
                  >
                    <span>Home</span>
                  </DropdownItem>
                </li>
                <li>
                  <DropdownItem
                    tag="a"
                    href="#links"
                    onClick={(ev) => {
                      ev.preventDefault();
                      navigate("/welcome", {
                        state: { shouldStayOnWelcome: true },
                      });
                    }}
                  >
                    <span>Profile</span>
                  </DropdownItem>
                </li>
                <li>
                  <DropdownItem
                    tag="a"
                    href="#links"
                    onClick={(ev) => {
                      ev.preventDefault();
                      navigate("/user-detail", {
                        state: { shouldStayOnWelcome: true },
                      });
                    }}
                  >
                    <span>User Details</span>
                  </DropdownItem>
                </li>
              </ul>
            </DropdownMenu>
          </Dropdown>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          {cart > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                cursor: "pointer",
                marginTop: "18px",
              }}
              onClick={() => {
                handleCheckout();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                className="bi bi-cart-check-fill"
                viewBox="0 0 16 16"
                style={{ color: "#1a2853" }}
              >
                <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708" />
              </svg>
              <div className="text-end">
                <span className="togal_count">{cart}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {showLogo && (
        <BlockBetween>
          <BlockHeadContent className="">
            <img
              src={logoData?.logo_image}
              alt="logo"
              width={120}
              height={120}
              style={{ borderRadius: "60px" }}
            />
            <BlockTitle page tag="h1">
              {logoData?.title}
            </BlockTitle>
            <BlockDes className="text-soft banner_desc">
              <p>{logoData?.description}</p>
            </BlockDes>
          </BlockHeadContent>
        </BlockBetween>
      )}
    </BlockHead>
  );
};
